import React, { useState } from "react";
import StepSidebar from "./StepSidebar";
import YouTubeLightbox from "./YouTubeLightbox";

const ClientPortalLayout = ({
  householdData,
  currentStep,
  title,
  subtitle,
  headerAction,
  backLink,
  backLinkText,
  demoVideoUrl,
  children,
}) => {
  const [showDemoVideo, setShowDemoVideo] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <>
      <div className="min-h-screen bg-gray-50 flex">
        {/* Mobile sidebar overlay */}
        {sidebarOpen && (
          <div
            className="fixed inset-0 bg-black/40 z-40 md:hidden"
            onClick={() => setSidebarOpen(false)}
          />
        )}

        {/* Sidebar - hidden on mobile, always visible on md+ */}
        <div
          className={`fixed inset-y-0 left-0 z-50 transform transition-transform duration-200 ease-in-out md:relative md:translate-x-0 md:z-auto ${
            sidebarOpen ? "translate-x-0" : "-translate-x-full"
          }`}
        >
          <StepSidebar
            householdData={householdData}
            currentStep={currentStep}
            className="min-h-screen"
          />
        </div>

        {/* Main content area */}
        <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
          {/* Mobile header with hamburger */}
          <div className="flex items-center gap-3 px-4 pt-3 md:hidden">
            <button
              onClick={() => setSidebarOpen(true)}
              className="p-2 rounded-lg text-gray-600 hover:bg-gray-100 transition-colors"
              aria-label="Open menu"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          </div>

          {/* Back link */}
          {backLink && backLinkText && (
            <div className="px-4 sm:px-6 lg:px-8 pt-6">
              <button
                onClick={backLink}
                className="inline-flex items-center gap-1.5 text-sm text-gray-500 hover:text-gray-700 transition-colors"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                </svg>
                {backLinkText}
              </button>
            </div>
          )}

          {/* Title section */}
          <div className={`px-4 sm:px-6 lg:px-8 pb-6 ${backLink ? "pt-2" : "pt-8"}`}>
            <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3">
              <div>
                <h1 className="text-xl sm:text-2xl font-bold text-gray-900">{title}</h1>
                {subtitle && <p className="text-sm text-gray-500 mt-3">{subtitle}</p>}
              </div>
              <div className="flex items-center gap-3 flex-shrink-0">
                {demoVideoUrl && (
                  <button
                    onClick={() => setShowDemoVideo(true)}
                    className="flex items-center gap-1.5 text-sm text-emerald-600 hover:text-emerald-700 transition font-medium"
                  >
                    <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l6 4.5-6 4.5z" />
                    </svg>
                    Watch Demo
                  </button>
                )}
                {headerAction}
              </div>
            </div>
          </div>

          {/* Content area */}
          <main className="flex-1 overflow-y-auto px-4 sm:px-6 lg:px-8 pb-8">
            {children}
          </main>
        </div>
      </div>

      {/* Demo Video Lightbox */}
      <YouTubeLightbox
        videoUrl={demoVideoUrl}
        isOpen={showDemoVideo}
        onClose={() => setShowDemoVideo(false)}
      />
    </>
  );
};

export default ClientPortalLayout;
